import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PriceLevelContainer from '../../ticket-picker/containers/PriceLevelContainer';
import ProductContainer from '../../product-picker/containers/ProductContainer';
import BundlesContainer from '../../bundle-picker/containers/BundlesContainer'
import InventoryContentContainer from '../../ticket-picker/containers/InventoryContentContainer';
import TicketPickerCardHeader from '../../ticket-picker/components/TicketPickerCardHeader';

class UpsellInventoryPicker extends Component {
    render() {

        const priceLevels = Array.isArray(this.props.priceLevels) ? this.props.priceLevels : [];
        const products = Array.isArray(this.props.products) ? this.props.products : [];
        const bundles = Array.isArray(this.props.bundles) ? this.props.bundles : [];

        return(
            <InventoryContentContainer>
                {!!priceLevels.length && (
                    <TicketPickerCardHeader header="Tickets">
                        {priceLevels.map((pl, index) => {
                            return (
                                <PriceLevelContainer
                                    key={index}
                                    reducerKey={this.props.reducerKey}
                                    levelId={pl.price_level_id}
                                    disabled={!!this.props.disabled}
                                />
                            );
                        })}
                    </TicketPickerCardHeader>
                )}
                {!!products.length && (
                    <TicketPickerCardHeader header="Add Ons">
                        {products.map((product, index) => {
                            return (
                                <ProductContainer
                                    key={index}
                                    reducerKey={this.props.reducerKey}
                                    productId={product.product_id}
                                    disabled={!!this.props.disabled}
                                />
                            );
                        })}
                    </TicketPickerCardHeader>
                )}
                {!!bundles.length && <BundlesContainer reducerKey={this.props.reducerKey} />}
            </InventoryContentContainer>
        )
    }
}

UpsellInventoryPicker.propTypes = {
    reducerKey: PropTypes.string,
    priceLevels: PropTypes.array,
    products: PropTypes.array,
    bundles: PropTypes.array,
    disabled: PropTypes.bool,
}

export default UpsellInventoryPicker;
